if (!customElements.get('lookbook-card-slider')) {
  customElements.define(
    'lookbook-card-slider',
    class LookbookCardSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector('.swiper');
        if (!this.sliderWrapper) {
          return;
        }

        this.lookbookIcons = this.querySelectorAll('lookbook-icon');
        this.sliderInstance = false;

        this.boundLookbookIconMouseOver = this.onMouseOver.bind(this);
        this.boundLookbookIconMouseLeave = this.onMouseLeave.bind(this);
        this.boundLookbookIconClick = this.onClickHotspot.bind(this);
        this.boundLookbookIconFocusIn = this.onMouseOver.bind(this);
        this.boundLookbookIconFocusOut = this.onFocusOut.bind(this);
        Array.from(this.lookbookIcons).forEach((icon) => {
          icon.addEventListener('mouseover', this.boundLookbookIconMouseOver);
          icon.addEventListener('mouseleave', this.boundLookbookIconMouseLeave);
          icon.addEventListener('click', this.boundLookbookIconClick);
          icon.addEventListener('focusin', this.boundLookbookIconFocusIn);
          icon.addEventListener('focusout', this.boundLookbookIconFocusOut);
        });

        if (this.dataset.staticDesktop === 'true') {
          this.staticDesktopMediaQuery = window.matchMedia('(min-width: 768px)');
          this.boundStaticDesktopMediaQueryChange = this.handleStaticDesktopMediaQueryChange.bind(this);
          this.staticDesktopMediaQuery.addEventListener('change', this.boundStaticDesktopMediaQueryChange);
          this.handleStaticDesktopMediaQueryChange();
        } else {
          this.initSlider();
        }
      }

      disconnectedCallback() {
        if (this.staticDesktopMediaQuery) {
          this.staticDesktopMediaQuery.removeEventListener('change', this.boundStaticDesktopMediaQueryChange);
        }
        Array.from(this.lookbookIcons || []).forEach((icon) => {
          icon.removeEventListener('mouseover', this.boundLookbookIconMouseOver);
          icon.removeEventListener('mouseleave', this.boundLookbookIconMouseLeave);
          icon.removeEventListener('click', this.boundLookbookIconClick);
          icon.removeEventListener('focusin', this.boundLookbookIconFocusIn);
          icon.removeEventListener('focusout', this.boundLookbookIconFocusOut);
        });
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }

      isStaticDesktopLayout() {
        return this.dataset.staticDesktop === 'true' && window.matchMedia('(min-width: 768px)').matches;
      }

      handleStaticDesktopMediaQueryChange() {
        if (this.dataset.staticDesktop !== 'true') return;

        if (this.isStaticDesktopLayout()) {
          if (this.sliderInstance && this.sliderInstance.slider) {
            this.sliderInstance.slider.destroy();
            this.sliderInstance = false;
          }
          const wrap = this.sliderWrapper.querySelector('.swiper-wrapper');
          if (wrap && !wrap.classList.contains('f-grid')) {
            wrap.classList.add('f-grid');
          }
          if (wrap) {
            wrap.style.removeProperty('transform');
            wrap.style.removeProperty('translate');
            wrap.querySelectorAll('.swiper-slide').forEach((slide) => {
              slide.style.removeProperty('width');
              slide.style.removeProperty('height');
              slide.style.removeProperty('margin-right');
              slide.style.removeProperty('margin-left');
            });
          }
          this.sliderWrapper.style.removeProperty('height');
          this.classList.add('lookbook--static-desktop-layout');
          this.fixQuickviewDuplicate();
        } else {
          this.classList.remove('lookbook--static-desktop-layout');
          if (!this.sliderInstance || !this.sliderInstance.slider) {
            this.initSlider();
          }
        }
      }

      setActiveCardByProductIndex(productIndex) {
        this.sliderWrapper.querySelectorAll('.f-column .product-card').forEach((productCard) => {
          productCard.classList.remove('is-active');
        });
        const column = this.sliderWrapper.querySelector('.f-column[data-product-index="' + productIndex + '"]');
        const productCard = column && column.querySelector('.product-card');
        if (productCard) productCard.classList.add('is-active');
      }

      initSlider() {
        if (this.dataset.staticDesktop === 'true' && window.matchMedia('(min-width: 768px)').matches) {
          return;
        }
        if (this.sliderInstance && this.sliderInstance.slider) {
          return;
        }

        const items = parseInt(this.dataset.items);
        const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          init: false,
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          breakpoints: {
            768: {
              slidesPerView: items,
            },
          },
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },
          speed: 500,
          loop: true,
          threshold: 2,
        };

        this.sliderCounter = this.querySelector('.swiper-pagination-counter');
        this.sliderWrapper.querySelector('.swiper-wrapper').classList.remove('f-grid');

        this.calcNavButtonsPosition();

        this.sliderInstance = new window.FoxTheme.Carousel(this.sliderWrapper, this.sliderOptions);
        this.sliderInstance.init();

        this.sliderInstance.slider.on('afterInit', this.onSlideAfterInit.bind(this));
        this.sliderInstance.slider.on('realIndexChange', this.onSlideChange.bind(this));

        this.sliderInstance.slider.init();

        this.fixQuickviewDuplicate();
      }

      calcNavButtonsPosition() {
        if (this.dataset.calcButtonPosition !== 'true') return;
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.style.removeProperty('--swiper-navigation-top-offset');
          return;
        }

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        if (firstMedia && firstMedia.clientHeight > 0) {
          this.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      getProductIndexFromSlideElement(slideElement) {
        if (slideElement.dataset.productIndex !== undefined && slideElement.dataset.productIndex !== '') {
          return Number(slideElement.dataset.productIndex);
        }
        return Number(slideElement.dataset.swiperSlideIndex);
      }

      onSlideAfterInit(swiper) {
        const { realIndex } = swiper;
        if (this.sliderCounter && swiper.pagination.bullets) {
          this.sliderCounter.querySelector('.swiper-pagination-current').innerText = realIndex + 1;
          this.sliderCounter.querySelector('.swiper-pagination-total').innerText = swiper.pagination.bullets.length;
        }

        this.detectVisibleSlides(swiper);
      }

      onSlideChange(swiper) {
        const { slides, realIndex } = swiper;

        this.detectVisibleSlides(swiper);

        if (slides[realIndex]) {
          Array.from(this.lookbookIcons).forEach((icon) => icon.classList.remove('is-active'));
          const activeIcon = this.querySelector('lookbook-icon[data-product-index="' + realIndex + '"]');
          if (activeIcon) activeIcon.classList.add('is-active');
        }

        if (this.sliderCounter && swiper.pagination.bullets) {
          this.sliderCounter.querySelector('.swiper-pagination-current').innerText = realIndex + 1;
        }
      }

      detectVisibleSlides(swiper) {
        const {
          activeIndex,
          params: { slidesPerView },
        } = swiper;

        this.activeIndexs = [];
        for (let i = 0; i < slidesPerView; i++) {
          const slideIndex = (activeIndex + i) % swiper.slides.length;
          const slideEl = swiper.slides[slideIndex];
          if (slideEl) {
            this.activeIndexs.push(this.getProductIndexFromSlideElement(slideEl));
          }
        }

        this.animateVisiblePins();
      }

      animateVisiblePins() {
        this.resetAnimatePins();
        this.startAnimatePins();
      }

      resetAnimatePins() {
        Array.from(this.lookbookIcons).forEach((icon) => icon.classList.remove('is-visible'));
      }

      startAnimatePins() {
        if (this.isStaticDesktopLayout()) {
          this.querySelectorAll('lookbook-icon').forEach((icon) => icon.classList.add('is-visible'));
          return;
        }
        Array.from(this.activeIndexs || []).forEach((productIndex) => {
          const icon = this.querySelector('lookbook-icon[data-product-index="' + productIndex + '"]');
          if (icon) icon.classList.add('is-visible');
        });
      }

      onClickHotspot(event) {
        if (!this.isStaticDesktopLayout()) return;
        event.preventDefault();
        const productIndex = Number(event.currentTarget.dataset.productIndex);
        if (Number.isNaN(productIndex)) return;
        Array.from(this.lookbookIcons).forEach((icon) => icon.classList.remove('is-active'));
        event.currentTarget.classList.add('is-active');
        this.setActiveCardByProductIndex(productIndex);
        this.classList.add('is-hovering');
        this.resetAnimatePins();
      }

      onMouseOver(event) {
        const target = event.currentTarget;
        const productIndex = Number(target.dataset.productIndex);
        if (Number.isNaN(productIndex)) return;
        target.classList.add('is-active');

        if (this.isStaticDesktopLayout()) {
          this.setActiveCardByProductIndex(productIndex);
          this.classList.add('is-hovering');
          this.resetAnimatePins();
          return;
        }

        if (typeof this.sliderInstance.slider === 'object') {
          if (this.sliderOptions.loop) {
            this.sliderInstance.slider.slideToLoop(productIndex, this.sliderOptions.speed);
          } else {
            this.sliderInstance.slider.slideTo(productIndex, this.sliderOptions.speed);
          }

          this.classList.add('is-hovering');

          this.resetAnimatePins();
        }
      }

      onFocusOut(event) {
        if (event.currentTarget.contains(event.relatedTarget)) return;
        this.onMouseLeave();
      }

      onMouseLeave() {
        this.sliderWrapper.querySelectorAll('.f-column .product-card').forEach((productCard) => {
          productCard.classList.remove('is-active');
        });
        Array.from(this.lookbookIcons).forEach((icon) => icon.classList.remove('is-active'));
        this.classList.remove('is-hovering');

        if (this.isStaticDesktopLayout()) {
          this.resetAnimatePins();
          this.querySelectorAll('lookbook-icon').forEach((icon) => icon.classList.add('is-visible'));
          return;
        }

        this.startAnimatePins();
      }
    }
  );
}
